<div class="container-fluid">
  <div class="row">
    <div class="col col-md-3 col-xl-3 ion-text-left ion-no-padding">
      <a href="/"><svg class="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 202 44"><defs><style>.gigexchange{fill:#fff;}</style></defs><title>gigexchange</title><path class="gigexchange" d="M36.7,19.61a1.59,1.59,0,0,0-2.25,0,1.61,1.61,0,0,0,0,2.25,4.61,4.61,0,0,1-6.52,6.52L25,25.43l3.25-3.26a7.79,7.79,0,0,0,0-11h0a7.72,7.72,0,0,0-5.5-2.28h0a7.72,7.72,0,0,0-5.5,2.28l-.08.09a7.8,7.8,0,0,0,.09,10.92l2.56,2.54,2.24-2.26-2.56-2.53a4.61,4.61,0,0,1,0-6.52A4.61,4.61,0,0,1,26,19.93l-8.45,8.45A4.61,4.61,0,0,1,11,21.86a1.59,1.59,0,1,0-2.24-2.25,7.79,7.79,0,0,0,11,11l2.94-2.95,3,2.95a7.79,7.79,0,0,0,11-11Z"/><path class="gigexchange" d="M121.45,32a6.45,6.45,0,1,1,5.32-10.08,1.11,1.11,0,0,1-.29,1.53,1.1,1.1,0,0,1-1.52-.29,4.25,4.25,0,1,0,.05,4.72,1.1,1.1,0,0,1,1.83,1.21A6.44,6.44,0,0,1,121.45,32ZM186,25.64V33.1a6.44,6.44,0,0,1-12.88,0,1.1,1.1,0,0,1,2.19,0,4.25,4.25,0,0,0,8.5,0V30.4A6.37,6.37,0,0,1,179.6,32,6.44,6.44,0,1,1,186,25.58Zm-2.19-.06a4.25,4.25,0,1,0-4.25,4.25A4.25,4.25,0,0,0,183.85,25.58Zm-95.92-.14V33.1a6.44,6.44,0,0,1-12.88,0,1.1,1.1,0,0,1,2.19,0,4.25,4.25,0,1,0,8.5,0V30.4A6.37,6.37,0,0,1,81.49,32a6.44,6.44,0,1,1,6.43-6.72S87.93,25.39,87.93,25.44Zm-2.19.14a4.25,4.25,0,1,0-4.25,4.25A4.25,4.25,0,0,0,85.74,25.58Zm15.9,3.53a1.09,1.09,0,1,0-1.83-1.2,4.25,4.25,0,0,1-7.66-1.24h9.45a1.09,1.09,0,0,0,1.1-1.09,6.45,6.45,0,1,0-1.06,3.53Zm-1.28-4.63H92.15a4.25,4.25,0,0,1,8.21,0Zm99.39,4.63a1.09,1.09,0,1,0-1.83-1.2,4.25,4.25,0,0,1-7.66-1.24h9.45a1.09,1.09,0,0,0,1.1-1.09,6.45,6.45,0,1,0-1.06,3.53Zm-1.28-4.63h-8.21a4.25,4.25,0,0,1,8.21,0ZM69.09,25.63V33.1a6.44,6.44,0,0,1-12.88,0,1.1,1.1,0,0,1,2.19,0,4.25,4.25,0,0,0,8.5,0V30.4A6.37,6.37,0,0,1,62.65,32a6.44,6.44,0,1,1,6.44-6.44Zm-2.19-.05a4.25,4.25,0,1,0-4.25,4.25A4.25,4.25,0,0,0,66.9,25.58Zm6.26,5.1V20.39a1.1,1.1,0,1,0-2.19,0V30.68a1.1,1.1,0,1,0,2.19,0Zm0-13.69A1.1,1.1,0,0,0,71,17v0a1.1,1.1,0,1,0,2.19,0Zm62.16,2.15a6.4,6.4,0,0,0-4.25,1.61v-7a1.1,1.1,0,1,0-2.19,0V30.94a1.1,1.1,0,0,0,2.19,0V25.58a4.25,4.25,0,1,1,8.5,0v5.36a1.1,1.1,0,0,0,2.19,0V25.58A6.45,6.45,0,0,0,135.32,19.14Zm29.51,0a6.37,6.37,0,0,0-4.25,1.62v-.47a1.1,1.1,0,0,0-2.19,0V30.93a1.1,1.1,0,1,0,2.19,0V25.57a4.25,4.25,0,1,1,8.5,0v5.36a1.1,1.1,0,1,0,2.19,0V25.57A6.45,6.45,0,0,0,164.83,19.13ZM156.51,26v5.17a1.1,1.1,0,0,1-2.19,0v-.71a6.44,6.44,0,1,1,0-9.69v-.38a1.1,1.1,0,0,1,2.19,0V25.2c0,.12,0,.25,0,.38S156.51,25.83,156.51,26Zm-2.19,0V25.2a4.25,4.25,0,1,0,0,.76Zm-44-.36L114.57,21a1.09,1.09,0,0,0-.06-1.55,1.08,1.08,0,0,0-1.54.06L108.83,24l-4.13-4.45A1.1,1.1,0,1,0,103.09,21l4.25,4.57-4.25,4.58a1.1,1.1,0,0,0,.06,1.55,1.12,1.12,0,0,0,.75.29,1.11,1.11,0,0,0,.8-.35l4.13-4.46L113,31.67a1.08,1.08,0,0,0,.8.35,1.12,1.12,0,0,0,.74-.29,1.09,1.09,0,0,0,.06-1.55Z"/></svg></a>
    </div>
    <div class="col col-md-6 ion-hide-md-down">
      <nav class="ion-padding">
        <li class="nav-item" (mouseenter)="loadGigs()"><a href="/gigs"><span class="ion-link ion-padding">Gigs</span></a>
          <div class="dropdown-menu gigs">
            <div class="row">
              <div class="col col-md-3 col-xl-3 ion-text-left">
                <h2>Self Employed</h2>
                <p>Whether you are a freelancer or contractor already in the gig economy. A Full Time Employee looking to boost your income opportunities through a side hustle.<br />
                  <a href="{{webURL}}/self-employed"><button class="button-solid button-tertiary button-round">View articles</button></a>
                </p>
              </div>
              <div class="col col-md-6 col-xl-5 col-xl-offset-1 ion-text-left">
                <div class="row">
                  <div class="col col-md-6 ion-text-left">
                    <h4 class="ion-margin-top ion-margin-bottom">Gig Listers</h4>
                    <ng-container *ngIf="auth.user | async as user; else gigsmenu">
                      <a href="/account/gigs/create">
                        <img loading="lazy" src="/assets/images/gig-lister.webp" width="600" height="225" /><br>
                      </a>
                      <p *ngIf="!user.welcome && user.giglister">
                        <a href="/account/gigs/create">List a Gig</a>
                      </p>
                      <p *ngIf="!user.welcome && user.giglister">
                        <a href="/account/gigs">My Listed Gigs</a>
                      </p>
                      <p *ngIf="!user.welcome && !user.giglister">
                        <a href="/account/dashboard">Get Started</a>
                      </p>
                    </ng-container>
                    <ng-template #gigsmenu>
                      <a href="/account/dashboard">
                        <img loading="lazy" src="/assets/images/gig-lister.webp" width="600" height="225" /><br>
                      </a>
                      <p>
                        <a href="/account/dashboard">Get Started</a>
                      </p>
                    </ng-template>
                  </div>
                  <div class="col col-md-6 ion-text-left">
                    <h4 class="ion-margin-top ion-margin-bottom">Gig Workers</h4>
                    <a href="/gigs">
                      <img loading="lazy" src="/assets/images/gig-workers.webp" width="600" height="225" /><br>
                    </a>
                    <p>
                      <a href="/gigs">Available Gigs</a>
                    </p>
                    <ng-container *ngIf="auth.user | async as user;">
                      <p *ngIf="!user.welcome && user.gigster">
                        <a href="/account/gigs/feed">My Applications</a>
                      </p>
                      <p *ngIf="!user.welcome && !user.gigster">
                        <a href="/account/dashboard">Get Started</a>
                      </p>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="col col-md-3 col-xl-2 col-xl-offset-1 ion-text-left">
                <h4>Latest Gigs</h4>
                <p *ngFor="let gig of gigsintown | async;">
                  <a href="/gigs/detail/{{gig.slug}}">{{gig.title}}</a>
                </p>
                <p>
                  <a href="/gigs"><button class="button-solid button-tertiary button-round">View ads</button></a>
                </p>
              </div>
            </div>
          </div>
        </li>
        <li class="nav-item" (mouseenter)="loadJobs()"><a href="/jobs"><span class="ion-link ion-padding">Jobs</span></a>
          <div class="dropdown-menu jobs">
            <div class="row">
              <div class="col col-md-3 col-xl-3 ion-text-left">
                <h2>Job Market</h2>
                <p>Adding the reputation & Intelligence into finding first class candidates. Whilst enabling job hunters to build their platform reputation to land dream jobs & contracts.<br />
                  <a href="{{webURL}}/job-market"><button class="button-solid button-tertiary button-round">View articles</button></a>
                </p>
              </div>
              <div class="col col-md-6 col-xl-5 col-xl-offset-1 ion-text-left">
                <div class="row">
                  <div class="col col-md-6 ion-text-left">
                    <h4 class="ion-margin-top ion-margin-bottom">Job Listers</h4>
                    <ng-container *ngIf="auth.user | async as user; else jobsmenu">
                      <a href="/jobs">
                        <img loading="lazy" src="/assets/images/how-it-works/jobs.webp" width="600" height="225" /><br>
                      </a>
                      <p *ngIf="!user.welcome && user.joblister">
                        <a href="/account/jobs/create">List a Job</a>
                      </p>
                      <p *ngIf="!user.welcome && user.joblister">
                        <a href="/account/jobs">My Listed Jobs</a>
                      </p>
                      <p *ngIf="!user.welcome && !user.joblister">
                        <a href="/account/dashboard">Get Started</a>
                      </p>
                    </ng-container>
                    <ng-template #jobsmenu>
                      <a href="/account/dashboard">
                        <img loading="lazy" src="/assets/images/how-it-works/jobs.webp" width="600" height="225" /><br>
                      </a>
                      <p>
                        <a href="/account/dashboard">Get Started</a>
                      </p>
                    </ng-template>
                  </div>
                  <div class="col col-md-6 ion-text-left">
                    <h4 class="ion-margin-top ion-margin-bottom">Job Hunters</h4>
                    <a href="/jobs">
                      <img loading="lazy" src="/assets/images/job-hunter.webp" width="600" height="225" /><br>
                    </a>
                    <p>
                      <a href="/jobs">Available Jobs</a>
                    </p>
                    <ng-container *ngIf="auth.user | async as user;">
                      <p *ngIf="!user.welcome && user.jobhunter">
                        <a href="/account/jobs/feed">My Applications</a>
                      </p>
                      <p *ngIf="!user.welcome && !user.jobhunter">
                        <a href="/account/dashboard">Get Started</a>
                      </p>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="col col-md-3 col-xl-2 col-xl-offset-1 ion-text-left">
                <h4>Latest Jobs</h4>
                <p *ngFor="let job of jobsintown | async;">
                  <a href="/jobs/detail/{{job.slug}}">{{job.title}}</a>
                </p>
                <p>
                  <a href="/jobs"><button class="button-solid button-tertiary button-round">View ads</button></a>
                </p>
              </div>
            </div>
          </div>
        </li>
        <li class="nav-item" (mouseenter)="loadVols()"><a href="/volunteers"><span class="ion-link ion-padding">Volunteers</span></a>
          <div class="dropdown-menu volunteers">
            <div class="row">
              <div class="col col-md-3 col-xl-3 ion-text-left">
                <h2>Volunteering</h2>
                <p>Putting the ease, convenience and recognition into volunteering and finding volunteers.<br />
                  <a href="{{webURL}}/volunteering"><button class="button-solid button-tertiary button-round">View articles</button></a>
                </p>
              </div>
              <div class="col col-md-6 col-xl-5 col-xl-offset-1 ion-text-left">
                <div class="row">
                  <div class="col col-md-6 ion-text-left">
                    <h4 class="ion-margin-top ion-margin-bottom">Requestors</h4>
                    <ng-container *ngIf="auth.user | async as user; else volsmenu">
                      <a href="/volunteers">
                        <img loading="lazy" src="/assets/images/job-listers.webp" width="600" height="225" /><br>
                      </a>
                      <p *ngIf="!user.welcome && user.volseeker">
                        <a href="/account/volunteers/create">List Ad</a>
                      </p>
                      <p *ngIf="!user.welcome && user.volseeker">
                        <a href="/account/volunteers">My Listed Ads</a>
                      </p>
                      <p *ngIf="!user.welcome && !user.volseeker">
                        <a href="/account/dashboard">Get Started</a>
                      </p>
                    </ng-container>
                    <ng-template #volsmenu>
                      <a href="/account/dashboard">
                        <img loading="lazy" src="/assets/images/job-listers.webp" width="600" height="225" /><br>
                      </a>
                      <p>
                        <a href="/account/dashboard">Get Started</a>
                      </p>
                    </ng-template>
                  </div>
                  <div class="col col-md-6 ion-text-left">
                    <h4 class="ion-margin-top ion-margin-bottom">Volunteers</h4>
                    <a href="/volunteers">
                      <img loading="lazy" src="/assets/images/gigster.webp" width="600" height="225" /><br>
                    </a>
                    <p>
                      <a href="/volunteers">Available Ads</a>
                    </p>
                    <ng-container *ngIf="auth.user | async as user;">
                      <p *ngIf="!user.welcome && user.volunteer">
                        <a href="/account/volunteers/feed">My Applications</a>
                      </p>
                      <p *ngIf="!user.welcome && !user.volunteer">
                        <a href="/account/dashboard">Get Started</a>
                      </p>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="col col-md-3 col-xl-2 col-xl-offset-1 ion-text-left">
                <h4>Latest Ads</h4>
                <p *ngFor="let vol of volsintown | async;">
                  <a href="/volunteers/detail/{{vol.slug}}">{{vol.title}}</a>
                </p>
                <p>
                  <a href="/volunteers"><button class="button-solid button-tertiary button-round">View ads</button></a>
                </p>
              </div>
            </div>
          </div>
        </li>
        <li class="nav-item" (mouseenter)="loadAds()"><a href="/promote"><span class="ion-link ion-padding">Promote</span></a>
          <div class="dropdown-menu promote">
            <div class="row">
              <div class="col col-md-3 col-xl-3 ion-text-left">
                <h2>Small Business</h2>
                <p>Advertise your business or freelance service whilst growing your reputation through our platforms integrated ratings and reviews.<br />
                  <a href="{{webURL}}/small-business"><button class="button-solid button-tertiary button-round">View articles</button></a>
                </p>
              </div>
              <div class="col col-md-6 col-xl-5 col-xl-offset-1 ion-text-left">
                <div class="row">
                  <div class="col col-md-6 ion-text-left">
                    <h4 class="ion-margin-top ion-margin-bottom">Promoters</h4>
                    <ng-container *ngIf="auth.user | async as user; else adsmenu">
                      <a href="/promote">
                        <img loading="lazy" src="/assets/images/how-it-works/promoter.webp" width="600" height="225" /><br>
                      </a>
                      <p *ngIf="!user.welcome && user.promoter">
                        <a href="/account/promote/create">List Ad</a>
                      </p>
                      <p *ngIf="!user.welcome && user.promoter">
                        <a href="/account/promote">My Listed Ads</a>
                      </p>
                      <p *ngIf="!user.welcome && !user.promoter">
                        <a href="/account/dashboard">Get Started</a>
                      </p>
                    </ng-container>
                    <ng-template #adsmenu>
                      <a href="/account/dashboard">
                        <img loading="lazy" src="/assets/images/how-it-works/promoter.webp" width="600" height="225" /><br>
                      </a>
                      <p>
                        <a href="/account/dashboard">Get Started</a>
                      </p>
                    </ng-template>
                  </div>
                  <div class="col col-md-6 ion-text-left">
                    <h4 class="ion-margin-top ion-margin-bottom">Customers</h4>
                    <a href="/promote">
                      <img loading="lazy" src="/assets/images/advertising.webp" width="600" height="225" /><br>
                    </a>
                    <p>
                      <a href="/promote">Available Ads</a>
                    </p>
                    <ng-container *ngIf="auth.user | async as user;">
                      <p *ngIf="!user.welcome && user.customer">
                        <a href="/account/promote/feed">My Applications</a>
                      </p>
                      <p *ngIf="!user.welcome && !user.customer">
                        <a href="/account/dashboard">Get Started</a>
                      </p>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="col col-md-3 col-xl-2 col-xl-offset-1 ion-text-left">
                <h4>Latest Ads</h4>
                <p *ngFor="let ad of adsintown | async;">
                  <a href="/promote/detail/{{ad.slug}}">{{ad.title}}</a>
                </p>
                <p>
                  <a href="/promote"><button class="button-solid button-tertiary button-round">View ads</button></a>
                </p>
              </div>
            </div>
          </div>
        </li>
        <li class="nav-item"><a href="/how-it-works"><span class="ion-link ion-padding">How it works</span></a>
          <div class="dropdown-menu how-it-works">
            <div class="row">
              <div class="col col-md-3 col-xl-3 ion-text-left">
                <h2>How it works</h2>
                <p>Flexible Future of Work Opportunities<br />
                  <a href="/how-it-works"><button class="button-solid button-tertiary button-round">View how it works</button></a>
                </p>
              </div>
              <div class="col col-md-6 col-xl-5 col-xl-offset-1 ion-text-left">
                <div class="row">
                  <div class="col col-md-6 ion-text-left">
                    <h4 class="ion-margin-top ion-margin-bottom">Services</h4>
                    <a href="/how-it-works/gig-economy">
                      <img loading="lazy" src="/assets/images/how-it-works/gigs.webp" width="600" height="225" /><br>
                    </a>
                    <p>
                      <a href="/how-it-works/gig-economy">Gigs</a>
                    </p>
                    </div>
                  <div class="col col-md-6 ion-text-left">
                    <h4 class="ion-margin-top ion-margin-bottom">&nbsp;</h4>
                    <a href="/how-it-works/jobs-site">
                      <img loading="lazy" src="/assets/images/how-it-works/jobs.webp" width="600" height="225" /><br>
                    </a>
                    <p>
                      <a href="/how-it-works/jobs-site">Jobs</a>
                    </p>
                  </div>
                  <div class="col col-md-6 ion-text-left">
                    <a href="/how-it-works/volunteers">
                      <img loading="lazy" src="/assets/images/how-it-works/volunteers.webp" width="600" height="225" /><br>
                    </a>
                    <p>
                      <a href="/how-it-works/volunteers">Volunteers</a>  
                    </p>
                  </div>
                  <div class="col col-md-6 ion-text-left">
                    <a href="/how-it-works/promote-advertising">
                      <img loading="lazy" src="/assets/images/how-it-works/promoter.webp" width="600" height="225" /><br>
                    </a>
                    <p>
                      <a href="/how-it-works/promote-advertising">Promote</a>
                    </p>
                  </div>
                </div>
              </div>
              <div class="col col-md-3 col-xl-2 col-xl-offset-1 ion-text-left">
                <h4>Pricing</h4>
                <p>Check out our fair pricing<br />
                  <a href="/pricing"><button class="button-solid button-tertiary button-round">View pricing</button></a>
                </p>
              </div>
            </div>
          </div>
        </li>
        <li class="nav-close"><button class="button-round button-tertiary"><svg xmlns="http://www.w3.org/2000/svg" class="ionicon ion-icon" viewBox="0 0 512 512"><path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"></path></svg></button></li>
      </nav>
    </div>
    <div class="col col-md-3 col-xl-3 ion-hide-md-down ion-text-right">
      <ng-container *ngIf="auth.user | async as user; else guestmenu">
        <a href="/account/dashboard">
          <button class="ion-chip button-small button-clear">
            <span class="ion-avatar button-round">
              <img *ngIf="user.pic" [src]="bucketURL + user.pic + '?alt=media'" onError="this.src='assets/icons/favicon.png'" alt="{{user.alias}}">
              <small *ngIf="!user.pic" class="initials">{{user.initials}}</small>
            </span>
            <span *ngIf="user.unread" class="ion-badge">{{user.unread}}</span>
            <label class="ion-label">Hello, {{user.firstname}}</label>
          </button>
        </a>
      </ng-container>
      <ng-template #guestmenu>
        <a href="/login"><button class="button-small button-round button-clear">Login</button></a>
        <a href="/sign-up"><button class="button-small button-round button-tertiary">Register</button></a>
      </ng-template>
    </div>
  </div>
</div>
